import { WriteoffCreateRequest, WriteoffView } from '../types/writeoffTypes';
import { AccountView } from '../../AccountService/types/accountTypes';

/**
 * Creates a WriteoffCreateRequest from account data.
 * Maps account fields to the writeoff structure expected by the backend.
 */
export const createWriteoffRequestFromAccount = (
  account: AccountView,
  company: string,
  center: string
): WriteoffCreateRequest => {
  // Calculate writeoff amount as account balance
  const writeoffAmount = account.balance || 0;

  const writeoffView: WriteoffView = {
    identifiers: {
      id: '', // Will be generated by backend
      caseId: account.id, // Account ID serves as the case ID
      company: company,
      center: center,
      accountNumber: account.accountNumber || '',
      visitKey: account.visitKey || '',
      writeoffNumber: '', // Will be generated by backend
    },
    status: 'Draft',
    createdDate: new Date().toISOString(),
    createdBy: '', // Will be set by backend from user context
    modifiedBy: '',
    patient: {
      accountNumber: account.accountNumber || '',
      firstName: account.patient?.firstName || '',
      lastName: account.patient?.lastName || '',
      middleName: account.patient?.middleName || '',
      serviceDate: account.encounterInfo?.serviceDate,
      payerName: account.primaryPayerInfo?.payerName || '',
      payerCode: account.primaryPayerInfo?.payerId || '',
    },
    detail: {
      writeoffAmount: writeoffAmount,
      reason: '', // User will fill this in
      justificationNotes: '', // User will fill this in
    },
    notes: [],
    approvals: [], // Approvals will be assigned by backend based on center configuration
  };

  return {
    writeoffView,
  };
};

/**
 * @deprecated Use createWriteoffRequestFromAccount instead
 */
export const createWriteoffRequest = (data: WriteoffCreateRequest): WriteoffCreateRequest => {
  return data;
};
